/**
 * Base view for other logs
 **/
import _ from 'underscore';

import BaseView from '../../base-view';
import Model from './model';
import Collection from './list/collection';
import template from './list/template.html';
import DateTimeView from '../field-date-time/view';
import Suggest from '../suggest/index';
import 'floatthead';

export default BaseView.extend({
	events: {
		'change [name="showAll"]': 'toggleColumns',
		'click [type="reset"]': 'onFormReset',
		'click thead th': 'sortRows',
		'click tr': 'selectRow'
	},

	template: _.template(template),

	initialize: function() {
		// create collection with bootstrapped rows
		this.collection = new Collection(window.logModelData || null);

		// create model with translations
		this.labels = new Model(window.labels || null);

		// listen to collection changes
		this.listenTo(this.collection, 'sort', this.renderList);

		// reference elements
		this.tableEl = this.query('.js-table');
		this.tableBodyEl = this.query('.js-table-body');
		this.showAllEl = this.query('.js-show-all');

		this.toggleColumns();
		this.createFilters();
		this.initDatePickers();

		this.renderList();
	},

	/**
	 * create filters for the list
	 **/
	createFilters: function() {
		var el = this.el.querySelector('.js-participant');

		if (el) {
			this.participantSuggestView = new Suggest.Views.Main({
				el: el,
				dataUrl: '/extranet/autocompleteparticipant'
			}).render();
		}
	},

	/**
	 * Render list based on models in collection
	 * Warning: IE < 10 doesn't support innerHTML or insertAdjacentHTML on tbody (and others)
	 * despite the docs say otherwise: https://msdn.microsoft.com/en-us/library/ms535902%28v=vs.85%29.aspx#methods
	 * The method for altering tbody in IE < 10 isn't adviced since it's performance heavy
	 **/
	renderList: function() {
		var tableRows = this.template({
				rows: this.collection.toJSON(),
				labels: this.labels.toJSON()
			}),
			tempNode,
			tempTable;

		// do it the fast, proper way
		if (!document.documentElement.classList.contains('lt-ie10')) {
			if (this.tableBodyEl)
			{
				this.tableBodyEl.innerHTML = tableRows;
			}
		} else {
			// here comes the pain

			// remove all rows in tbody
			while (this.tableBodyEl.rows[0]) {
				this.tableBodyEl.deleteRow(0);
			}

			// create temporarily div and table....
			tempNode = document.createElement('div');
			tempNode.innerHTML = '<table>' + tableRows + '</table>';
			tempTable = tempNode.firstChild;

			// move rows from tempTable to DOM table
			while (tempTable.rows[0]) {
				this.tableBodyEl.appendChild(tempTable.rows[0]);
			}
		}

		this.fixTableHeader();
	},

	/**
	 * create date / time pickers
	 **/
	initDatePickers: function() {
		this.dateTimeViewFrom = new DateTimeView({
			el: '.js-date-time-from'
		}).render();

		this.dateTimeViewUntil = new DateTimeView({
			el: '.js-date-time-until'
		}).render();
	},

	/**
	 * make the table header fixed on scroll
	 **/
	fixTableHeader: function() {
		$(this.tableEl).floatThead({
			scrollContainer: function($table) {
				return $table.closest('.table-wrapper');
			},
			copyTableClass: true,
			floatContainerClass: 'table-wrapper'
		});
	},

	/**
	 * destroy the fixed table header
	 **/
	destroyFixedTableHeader: function() {
		$(this.tableEl).floatThead('destroy');
	},

	/**
	 * show / hide additional columns
	 **/
	toggleColumns: function(e) {
		// not every log has a 'show all button'
		if (!this.showAllEl) {
			return;
		}

		var show = this.showAllEl.checked;
		if (this.tableEl)
		{
			this.tableEl.classList.toggle('is-expanded', show);
		}
		// destroy the fixedHeader first, then recreate with a delay
		// to make sure it's really destroyed
		// floatThead('reflow') doesn't work in this case
		this.destroyFixedTableHeader();
		setTimeout(function() {
			this.fixTableHeader();
		}.bind(this), 250);
	},

	/**
	 * sort collection based on clicked column
	 **/
	sortRows: function(e) {
		var el = e.currentTarget,
			sortProperty = el.getAttribute('data-sort'),
			sortDirection;

		// get the sort direction
		if (el.getAttribute('data-direction')) {
			sortDirection = (el.getAttribute('data-direction')) === 'asc' ? 'desc' : 'asc';
		} else {
			sortDirection = 'desc';
		}

		// update direction attribute on element
		el.setAttribute('data-direction', sortDirection);

		// sort collection
		this.collection.sortBy(sortProperty, sortDirection);
	},

	/**
	 * select a row in the table
	 **/
	selectRow: function(e) {
		// deselect other rows
		this.queryAll(this.tableEl, 'tr.is-selected').forEach(function(el) {
			el.classList.remove('is-selected');
		});

		e.currentTarget.classList.toggle('is-selected');
	},

	/**
	 * resets form and submit it
	 **/
	onFormReset: function(e) {
		// get form
		var form = e.currentTarget.form;

		// clear participant suggest view
		if (this.participantSuggestView) {
			this.participantSuggestView.clear();
		}

		// clear date inputs
		this.dateTimeViewFrom.clear();
		this.dateTimeViewUntil.clear();

		// reset selects
		this.queryAll(form, 'select option[selected]').forEach(function(selected) {
			selected.removeAttribute('selected');
		});

		// reset and submit form
		form.reset();
		form.submit();
	},

	render: function() {
		return this;
	}

});
